module.exports = __webpack_public_path__ + "img/ibook-logo-font.f39d587c.png";